// extracted by mini-css-extract-plugin
module.exports = {"logo":"logo__2Q-Qg","header-logo":"header-logo__5slrq","clickable":"clickable__H8Ooq"};